import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-square-checked",
  "use": "icon-si-glyph-square-checked-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-square-checked\" id=\"icon-si-glyph-square-checked\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>628</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1.000000, 2.000000)\" fill=\"#434343\">\n            <path d=\"M2.017,5.904 L3.888,4.031 L6.173,6.322 L12.265,0.221 L14.045,2.004 L6.084,9.977 L2.017,5.904 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M11.021,8.116 L11.021,11.042 L0.979,11.042 L0.979,0.958 L8.947,0.958 L10.021,0.025 L0.002,0.025 L0.002,11.961 L11.979,11.961 L12,7.083 L11.021,8.116 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-square-checked.svg
// module id = Cr/4
// module chunks = 62